<template>
    <button class="button is-fullwidth" @click="clear()" :class="{ 'is-loading' : isLoading }">CLEAR</button>
</template>

<script>

export default {
   methods: {
       clear() {
           this.$store.dispatch('setProfitSectionQueryToDefault');
           this.$store.dispatch('fetchProfitSectionInvoicesWithQuery');
       }
   },
   computed: {
       isLoading() {
           return this.$store.getters.getProfitSectionData.is_loading
       }
   },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitClearButton.vue